import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import Home from '../pages/home';
import Course from "../pages/Course";
import JobSearch from "../pages/JobSearch";
import User from "../pages/User";
import Enterprise from "../pages/discovery/enterprise";
import About from "../pages/discovery/about";
import Certification from "../pages/discovery/certification";
import News from "../pages/discovery/news";
import NewsDetail from "../pages/discovery/news-detail";
import Advisory from "../pages/discovery/advisory-form";
import Activity from "../pages/discovery/activity";
import Trainings from "../pages/discovery/trainings";
import ActDetail from "../pages/discovery/activity-detail";
import TraDetail from "../pages/discovery/trainings-detail";
import MineCourse from "../pages/course/mine-course";
import HistoryCourse from "../pages/course/history-course";
import CourseDetail from "../pages/course/course-detail";
import PeopleDetail from "../pages/job/detail";
import MineActive from "../pages/user/active";
import UserOrder from "../pages/user/order";
import Certificate from "../pages/user/certificate";
import CompanyCertificate from "../pages/user/companyCertificate";
import CompanyMaterial from "../pages/user/companyMaterial";
import PersonalMaterial from "../pages/user/personalMaterial";
import Discount from "../pages/user/discount";
import LoginPage from "../pages/login";
import Vlog from "../pages/vlog/video";
import DoPay from "../pages/user/doPay";
import Register from "../pages/login/register";
import UserInfo from "../pages/user/userInfo";
import UserInfoInput from "../pages/user/userInfoInput";
import GradesPage from "../pages/user/grades";
import AvatarPage from "../pages/user/avatar";
import Personnel from "../pages/job/personnel";
import opportunity from "../pages/job/opportunity";
import opportunityDetail from "../pages/job/opportunityDetail";
import Education from "../pages/user/educations";
import Works from "../pages/user/works";
import UserInfoInputName from "../pages/user/userInfoInputName";
import UserInfoInputCard from "../pages/user/userInfoInputCard";
import EducationModal from "../pages/user/educationModal";
import WorkModal from "../pages/user/workModal";
import ResumeModify from "../pages/user/resumeModify";
import UserInfoInputRealName from "../pages/user/userInfoInputRealname";
import PhotoPage from "../pages/user/resumeAvatar";
import ChangePhone from "../pages/user/changePhone";
import Skills from "../pages/user/skills";
import TelecastDetail from "../pages/home/telecast-detail";
import Resume from "../pages/user/resume";
import ResumeUserInfo from "../pages/user/resume-userinfo";
import MineOffline from "../pages/user/offline";
import PaymentInfoConfirm from "../pages/payment/info-confirm";
import NewUser from "../pages/discovery/new-user";
import HelpPage from '../pages/user/help'
import StoryDetail from "../pages/discovery/story-detail";
import AuthoritiesWithInfoConfirm from "../pages/discovery/authorities";
import DoWxPay from "../pages/payment/wxPay";
import Page500 from "../pages/page500";
import BackToWx from "../pages/home/backToWx";
import Distribution from "../pages/user/distribution";
import DistributionDetail from "../pages/user/distributionDetail";
import DistributionLists from "../pages/user/distributionLists";

export interface routesInterFace {
    path: string,
    component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>,
    indexRoute?: boolean,
    title?: string,
    exact?: boolean,
    children?: Array<routesInterFace>
}


const routes: Array<routesInterFace> = [
    {
        path: '/',
        component: Home,
        title: 'TIBA荷兰国际管家学院',
        exact: true
    },
    {
        path: '/home',
        component: Home,
        title: '发现',
        children: [
            {
                path: '/enterprise',
                component: Enterprise,
                title: '企业服务专区',
                children: [
                    {
                        path: "/form",
                        component: Advisory,
                        title: '企业咨询表单'
                    }
                ]
            },
            {
                path: '/new-user',
                component: NewUser,
                title: '新人注册有礼'
            },
            {
                path: '/about',
                component: About,
                title: '关于我们'
            },
            {
                path: '/certification',
                component: Certification,
                title: '国际职业管家联盟'
            },
            {
                path: '/news',
                component: News,
                title: '热点新闻',
                children: [
                    {
                        path: '/:newsId/detail',
                        component: NewsDetail,
                        title: '新闻详情'
                    }
                ]
            },
            {
                path: '/activity',
                component: Activity,
                title: '线下活动',
                children: [
                    {
                        path: '/:actId/detail',
                        title: '线下活动与培训详情',
                        component: ActDetail,

                    },
                ]
            },
            
            {
                path: '/distribution',
                component: Distribution,
                title: '课程分销',
                children:[
                    {
                        path: '/detail',
                        title: '课程分销',
                        component: DistributionDetail
                    },{
                         path: '/lists',
                        title: '课程分销',
                        component: DistributionLists
                    }
                ]
            },

            {
                path: '/trainings',
                component: Trainings,
                title: '线下培训',
                children: [
                    {
                        path: '/:actId/detail',
                        title: '线下活动与培训详情',
                        component: TraDetail,

                    },
                ]
            },

            {
                path: '/vlog',
                component: Vlog,
                title: '管家短视频'
            },
            {
                path: '/telecast/:id/detail',
                component: TelecastDetail,
                title: '直播详情'
            }
        ]
    },
    {
        path: '/course',
        component: Course,
        title: '课程',
        children: [
            {
                path: '/mine',
                component: MineCourse,
                title: '我的课程'
            },
            {
                path: '/history',
                component: HistoryCourse,
                title: '观看历史'
            },
            {
                path: '/:id/detail',
                component: CourseDetail,
                title: '课程详情'
            }
        ]
    },
    {
        path: '/job',
        component: JobSearch,
        title: '求职',
        children: [

            {
                path: '/personnel',
                component: Personnel,
                title: '人才库',
                children: [
                    {
                        path: '/:id/detail',
                        component: PeopleDetail,
                        title: '个人简历'
                    },
                ]
            },
            {
                path: '/opportunity',
                component: opportunity,
                title: '工作机会',
                children: [
                    {
                        path: '/:id/detail',
                        component: opportunityDetail,
                        title: '岗位详情'
                    }
                ]
            },
            {
                path: '/story/:id/detail',
                component: StoryDetail,
                title: '管家故事'
            }
        ]
    },
    {
        path: '/user',
        component: User,
        title: '个人中心',
        children: [
            {
                path: '/active',
                component: MineActive,
                title: '我的活动'
            },
            {
                path: '/help',
                component: HelpPage,
                title: '帮助与反馈'
            },
            {
                path: '/offline',
                component: MineOffline,
                title: '线下课申请记录'
            },
            {
                path: '/order',
                component: UserOrder,
                title: '我的订单'
            },
            {
                path: '/certificate',
                component: Certificate,
                title: '我的证书'
            },
            {
                path: '/companyCertificate',
                component: CompanyCertificate,
                title: '企业证书'
            },
            {
                path: '/companyMaterial',
                component: CompanyMaterial,
                title: '企业资料'
            },
            {
                path: '/personalMaterial',
                component: PersonalMaterial,
                title: '个人资料'
            },
            {
                path: '/discount',
                component: Discount,
                title: '兑换码与卡券'
            },
            {
                path: '/do-pay/:id',
                component: DoPay,
                title: '确认支付'
            },
            {
                path: '/info',
                component: UserInfo,
                title: '用户信息设置',
                children: [
                    {
                        path: '/nickname',
                        component: UserInfoInput,
                        title: '昵称设置'
                    },
                    {
                        path: '/name',
                        component: UserInfoInputName,
                        title: '姓名设置'
                    },
                    {
                        path: '/identity',
                        component: UserInfoInputCard,
                        title: '身份证设置'
                    },
                    {
                        path: '/avatar',
                        component: AvatarPage,
                        title: '头像设置'
                    },
                    {
                        path: '/education',
                        component: Education,
                        title: '教育经历',
                        children: [
                            {
                                path: '/add',
                                component: EducationModal,
                                title: '添加教育经历'
                            },
                            {
                                path: '/:id/modify',
                                component: EducationModal,
                                title: '修改教育经历'
                            }
                        ]
                    },
                    {
                        path: '/works',
                        component: Works,
                        title: '工作经历',
                        children: [
                            {
                                path: '/add',
                                component: WorkModal,
                                title: '添加工作经历'
                            },
                            {
                                path: '/:id/modify',
                                component: WorkModal,
                                title: '修改工作经历'
                            }
                        ]
                    },
                    {
                        path: '/resume',
                        component: ResumeModify,
                        title: '个人简历设置',
                        children: [
                            {
                                path: '/name',
                                component: UserInfoInputRealName,
                                title: '真实姓名'
                            },
                            {
                                path: '/photo',
                                component: PhotoPage,
                                title: '简历照片'
                            },
                            {
                                path: '/skill',
                                component: Skills,
                                title: '个人优势'
                            }
                        ]
                    },
                    {
                        path: '/change-phone',
                        component: ChangePhone,
                        title: '更换绑定手机'
                    }
                ]
            },
            {
                path: '/resume',
                component: Resume,
                title: '我的简历',
                children: [
                    {
                        path: '/userinfo',
                        component: ResumeUserInfo,
                        title: '个人信息'
                    }
                ]
            },
            {
                path: '/grades',
                component: GradesPage,
                title: '会员权益'
            },
            {
                path: '/info-confirm',
                component: PaymentInfoConfirm,
                title: '个人信息确认'
            }
        ]
    },
    {
        path: '/login',
        component: LoginPage,
        title: '登录',
        children: [
            {
                path: '/register',
                component: Register,
                title: '注册'
            }
        ]
    },
    {
        path: '/order/:id/confirm',
        component: AuthoritiesWithInfoConfirm,
        title: '个人信息确认'
    },
    {
        path: '/doWxPay',
        component: DoWxPay,
        title: '微信支付'
    },
    {
        path: '/500',
        component: Page500,
        title: '服务出错'
    },
    {
        path: '/wx',
        component: BackToWx,
        title: '返回微信'
    }
]

const _routes: Array<routesInterFace> = []

function routeFromConfig(lists: Array<routesInterFace>, prefix = '') {
    let length = lists.length;
    let index = 0;
    while (index < length) {
        const item = lists[index];
        item.path = prefix + item.path;
        _routes.push(item);
        if (item.children && item.children.length > 0) {
            routeFromConfig(item.children, item.path);
        }
        index++;
    }
}

// 路由配置转化
routeFromConfig(routes);

export default _routes;

